import * as gsap from "gsap";
import {Application} from "../../Application";
import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {Signal} from "../../core/Signal";
import {SceneItem} from "../SceneItem";
import {AnimationContext} from "./AnimationContext";

export class Animation {

    public id?: string;
    public delay?: number;
    public time?: number;
    public speed?: number;
    public ease?: string;
    public appear?: boolean;
    public repeat?: number;
    public readonly onUpdate = Signal<Callback>();
    public readonly onComplete = Signal<Callback>();
    public readonly scenePadding = 40;

    private readonly p0 = new PIXI.Point();
    private readonly p1 = new PIXI.Point();

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        this.onComplete();
        cb();
    }

    protected updatePaperCut(item: SceneItem) {
        item.updatePaperCut();
    }

    protected getLeftmostPosition(item: SceneItem, context: AnimationContext) {
        const bounds = item.getLocalBounds();
        return this.toItemX(1024 - Application.instance.size.x - (bounds.width + bounds.x) * Math.abs(item.scale.x) - this.scenePadding, item, context);
    }

    protected getRightmostPosition(item: SceneItem, context: AnimationContext) {
        const bounds = item.getLocalBounds();
        return this.toItemX(1024 + Application.instance.size.x - bounds.x * Math.abs(item.scale.x) + this.scenePadding, item, context);
    }

    protected toItemX(sceneX: number, item: SceneItem, context: AnimationContext) {
        this.p0.x = sceneX;
        return item.parent.toLocal(this.p0, context.scene.container, this.p1).x;
    }

    protected toItemY(sceneY: number, item: SceneItem, context: AnimationContext) {
        this.p0.y = sceneY;
        return item.parent.toLocal(this.p0, context.scene.container, this.p1).y;
    }

    protected toItemPoint(sceneX: number, sceneY: number, item: SceneItem, context: AnimationContext): { readonly x: number, readonly y: number } {
        this.p0.x = sceneX;
        this.p0.y = sceneY;
        return item.parent.toLocal(this.p0, context.scene.container, this.p1);
    }

    protected getEase(defaultEase: gsap.Ease) {
        switch (this.ease) {
            case "bounceOut":
                return Ease.bounceOut;
            case "expoOut":
                return Ease.expoOut;
            case "quartOut":
                return Ease.quartOut;
            case "sineIn":
                return Ease.sineIn;
            case "backOut":
                return Ease.backOut;
            case "squishStretch":
                return Ease.elasticOut.config(1.5, 0.75);
        }
        return defaultEase;
    }
}
